/**
 * ISO datetime → human string, shared by the Files list and the Premium
 * Selection provenance tooltip. Lifted out of `pages/submission/files/index.tsx`
 * where it started as a local helper.
 *
 * The separator differs by surface: Files uses the middot ("Apr 16, 2026 · 2:34
 * PM"), the InsCipher tooltip uses "at" ("Jul 24, 2026 at 5:44 PM") — both
 * straight from their Figma.
 */
export function formatDateTime(iso: string | null | undefined, separator = "·"): string {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const date = d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    const time = d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
    return `${date} ${separator} ${time}`;
}
